"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isScheduleGroupItem(object) {
    return checkScheduleGroupItem(object).fulfilled;
}
exports.isScheduleGroupItem = isScheduleGroupItem;
function checkScheduleGroupItem(object, options = { ignoreSuperfluousObjectProperties: true }) {
    const result = __1.check(object, __1.hasString("id"), __1.hasString("userId").optional(), __1.hasString("resourceId").optional()).withOptions(options).explain();
    if (object.userId === undefined && object.resourceId === undefined) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$",
            explanation: "requires either userId or resourceId field",
            value: undefined,
        });
    }
    if (object.userId !== undefined && object.resourceId !== undefined) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$.resourceId",
            explanation: "cannot be set if userId is set",
            value: object.resourceId,
        });
    }
    return result;
}
exports.checkScheduleGroupItem = checkScheduleGroupItem;
//# sourceMappingURL=ScheduleGroupItem.js.map